(() => {
  if (customElements.get('wsc-diamond-collection-video')) return;

  class DiamondCollectionVideo extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      this.video = this.querySelector('video[data-src]');
      this.button = this.querySelector('button');
      if (!this.video || !this.button) return;
      this.attempt = (this.attempt || 0) + 1;
      this.requested = false;
      this.visible = false;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      const visibility = () => this.update();
      const motion = () => { this.manualPlay = false; this.update(); };
      const error = () => {
        this.blocked = true;
        this.mediaFailed = true;
        this.video.classList.remove('is-visible');
        this.stop();
      };
      const toggle = () => {
        if (this.requested) {
          this.userPaused = true;
          this.manualPlay = false;
          this.stop();
        } else {
          this.userPaused = false;
          this.manualPlay = true;
          this.blocked = false;
          this.update();
        }
      };
      this.button.addEventListener('click', toggle);
      this.video.addEventListener('error', error);
      this.motion.addEventListener('change', motion);
      document.addEventListener('visibilitychange', visibility);
      this.observer = new IntersectionObserver(([entry]) => {
        this.visible = entry.isIntersecting;
        this.update();
      });
      this.observer.observe(this);
      this.button.hidden = false;
      this.setControl(false);
      this.cleanup = () => {
        this.button.removeEventListener('click', toggle);
        this.video.removeEventListener('error', error);
        this.motion.removeEventListener('change', motion);
        document.removeEventListener('visibilitychange', visibility);
        this.observer.disconnect();
      };
    }

    eligible() {
      return this.isConnected && this.visible && !document.hidden && !this.userPaused && !this.blocked && (!this.motion.matches || this.manualPlay);
    }

    setControl(playing) {
      if (!this.button) return;
      this.button.dataset.playing = String(playing);
      this.button.setAttribute('aria-label', playing ? this.button.dataset.pauseLabel : this.button.dataset.playLabel);
    }

    stop() {
      this.attempt = (this.attempt || 0) + 1;
      this.requested = false;
      this.video?.pause();
      this.setControl(false);
    }

    update() {
      if (!this.eligible()) { this.stop(); return; }
      if (this.requested || !this.video.dataset.src) return;
      this.requested = true;
      const attempt = ++this.attempt;
      const video = this.video;
      if (!video.hasAttribute('src') || this.mediaFailed) {
        this.mediaFailed = false;
        video.src = video.dataset.src;
      }
      video.muted = true;
      this.setControl(true);
      const rejected = () => {
        if (attempt !== this.attempt) return;
        this.blocked = true;
        video.classList.remove('is-visible');
        this.stop();
      };
      try {
        Promise.resolve(video.play()).then(() => {
          if (attempt !== this.attempt || !this.eligible()) {
            if (!this.eligible() || !this.requested) video.pause();
            return;
          }
          video.classList.add('is-visible');
        }).catch(rejected);
      } catch {
        rejected();
      }
    }

    disconnectedCallback() {
      this.stop();
      this.cleanup?.();
      this.cleanup = null;
    }
  }

  customElements.define('wsc-diamond-collection-video', DiamondCollectionVideo);
})();
